module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAhSURBVBhXYzh0+Mh/bBi3xH8gQBcEAbAECCAL/v///z8AtDFS+XnKMA4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/images/del.png
// module id = 20I0
// module chunks = 65